export const setWidthToMaxContent = {
  width: "max-content",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontWeight: "400 !important",
};
